module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    attrs: {
      "id": "route-manage"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t('MANAGEROUTE')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "loading": _vm.saving || _vm.routing,
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [(!(_vm.saving || _vm.routing)) ? _c('i', {
    staticClass: "fa",
    class: _vm.submitIcon
  }) : _vm._e(), _vm._v(" \n           " + _vm._s(_vm.submissionText) + "\n           ")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('INFORMATION')
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: (_vm.cardHeight - 40) + 'px'
    })
  }, [_c('el-form', {
    ref: "infoForm",
    attrs: {
      "model": _vm.schedule,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DIRECTION'),
      "prop": "Direction",
      "rules": {
        type: 'number',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTDIRECTION')
    },
    on: {
      "change": _vm.setDepature
    },
    model: {
      value: (_vm.schedule.Direction),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Direction", $$v)
      },
      expression: "schedule.Direction"
    }
  }, _vm._l((_vm.directions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.ServiceDate !== '0' ? _vm.$t('SELECTSERVICEDATE') : _vm.$t('SELECTTERM')
    }
  }, [(_vm.ServiceDate !== 0) ? _c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECTTYPE')
    },
    model: {
      value: (_vm.ServiceDate),
      callback: function($$v) {
        _vm.ServiceDate = $$v
      },
      expression: "ServiceDate"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('ACADEMICYEAR'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('CUSTOMDATE'),
      "value": 1
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ServiceDate === 0) ? _c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('a', {
    staticClass: "el-input-group__prepend el-button el-icon-close",
    on: {
      "click": function($event) {
        _vm.ServiceDate = null
      }
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('SELECTACADEMICTERM')
    },
    on: {
      "change": _vm.setTerm
    },
    model: {
      value: (_vm.route.TermID),
      callback: function($$v) {
        _vm.$set(_vm.route, "TermID", $$v)
      },
      expression: "route.TermID"
    }
  }, _vm._l((_vm.terms), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.year,
        "value": item.YearID
      }
    })
  }))], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SERVICESTARTENDDATE'),
      "prop": "StartDate",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.ServiceDate === 0,
      "type": "date",
      "format": _vm.date_format,
      "placeholder": _vm.$t('PICKADATE')
    },
    model: {
      value: (_vm.schedule.StartDate),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "StartDate", $$v)
      },
      expression: "schedule.StartDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('SERVICESTARTENDDATE'),
      "prop": "EndDate",
      "rules": {
        type: 'date',
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.ServiceDate === 0,
      "type": "date",
      "format": _vm.date_format,
      "placeholder": _vm.$t('PICKADATE')
    },
    model: {
      value: (_vm.schedule.EndDate),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "EndDate", $$v)
      },
      expression: "schedule.EndDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DAYSINSERVICE')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('CHECKALL')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedDaysChange
    },
    model: {
      value: (_vm.schedule.ServiceDays),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "ServiceDays", $$v)
      },
      expression: "schedule.ServiceDays"
    }
  }, _vm._l((_vm.daysC), function(day, key) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": key.toString()
      }
    }, [_vm._v(_vm._s(day))])], 1)
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "timing"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('HOMETOSCHOOLSERVICETIME'),
      "prop": !_vm.schedule.Time_AM_In ? 'Time_AM_In' : 'Time_AM_Out',
      "rules": {
        required: (_vm.schedule.Direction == 1 || _vm.schedule.Direction == 3),
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 2,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '16:00'
      }
    },
    model: {
      value: (_vm.schedule.Time_AM_In),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_AM_In", $$v)
      },
      expression: "schedule.Time_AM_In"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('ENDTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 2,
      "picker-options": {
        start: _vm.schedule.Time_AM_In,
        step: '00:15',
        end: '16:00',
        minTime: _vm.schedule.Time_AM_In
      }
    },
    model: {
      value: (_vm.schedule.Time_AM_Out),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_AM_Out", $$v)
      },
      expression: "schedule.Time_AM_Out"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('SCHOOLTOHOMESERVICETIME'),
      "prop": !_vm.schedule.Time_PM_In ? 'Time_PM_In' : 'Time_PM_Out',
      "rules": {
        required: (_vm.schedule.Direction == 2 || _vm.schedule.Direction == 3),
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 1,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '16:00'
      }
    },
    model: {
      value: (_vm.schedule.Time_PM_In),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_PM_In", $$v)
      },
      expression: "schedule.Time_PM_In"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('ENDTIME'),
      "size": "small",
      "disabled": _vm.schedule.Direction === null || _vm.schedule.Direction === 1,
      "picker-options": {
        start: _vm.schedule.Time_PM_In,
        step: '00:15',
        end: '18:30',
        minTime: _vm.schedule.Time_PM_In
      }
    },
    model: {
      value: (_vm.schedule.Time_PM_Out),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "Time_PM_Out", $$v)
      },
      expression: "schedule.Time_PM_Out"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('el-form', {
    ref: "routeForm",
    staticStyle: {
      "padding": "0px !important"
    },
    attrs: {
      "model": _vm.route,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('NAME'),
      "prop": "TourName",
      "rules": [{
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'blur,change'
      }, {
        max: 15,
        message: _vm.$t('Maximum length should be 15 characters'),
        trigger: 'blur,change'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": _vm.$t('PLEASEINPUT')
    },
    model: {
      value: (_vm.route.TourName),
      callback: function($$v) {
        _vm.$set(_vm.route, "TourName", $$v)
      },
      expression: "route.TourName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DESCRIPTION')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": _vm.$t('PLEASEINPUT')
    },
    model: {
      value: (_vm.route.Description),
      callback: function($$v) {
        _vm.$set(_vm.route, "Description", $$v)
      },
      expression: "route.Description"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('STOPS'),
      "disabled": _vm.loading || _vm.stopTab
    }
  }, [_c('el-row', {
    staticClass: "only-bottom-border"
  }, [_c('el-autocomplete', {
    ref: "search",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.$t('ADDSTUDENTTOASTOP'),
      "icon": "search",
      "trigger-on-focus": false,
      "autofocus": ""
    },
    on: {
      "select": _vm.addStudent
    },
    model: {
      value: (_vm.studentSearch),
      callback: function($$v) {
        _vm.studentSearch = $$v
      },
      expression: "studentSearch"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    ref: "config",
    staticClass: "stopConfig",
    staticStyle: {
      "border-bottom": "1px solid rgb(204, 204, 204)"
    }
  }, [_c('el-steps', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "space": 100,
      "direction": "vertical",
      "active": 1
    }
  }, [_c('div', {
    staticClass: "el-step is-vertical"
  }, [_c('div', {
    staticClass: "el-step__head is-finish is-text",
    style: ({
      'background-color': _vm.direction.RouteColor,
      'border-color': _vm.direction.RouteColor
    })
  }, [_c('div', {
    staticClass: "el-step__line is-vertical",
    staticStyle: {
      "margin-right": "0px"
    },
    style: ({
      'background-color': _vm.direction.RouteColor
    })
  }, [_c('i', {
    staticClass: "el-step__line-inner",
    staticStyle: {
      "transition-delay": "0ms",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "el-step__icon"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-university"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "el-step__main"
  }, [_c('div', {
    staticClass: "el-step__title is-finish"
  }, [_c('el-color-picker', {
    staticStyle: {
      "margin-top": "-5px"
    },
    on: {
      "change": _vm.setPathColor
    },
    model: {
      value: (_vm.direction.RouteColor),
      callback: function($$v) {
        _vm.$set(_vm.direction, "RouteColor", $$v)
      },
      expression: "direction.RouteColor"
    }
  }), _vm._v(" "), _c('el-button-group', {
    staticClass: "btn-steps"
  }, [_c('el-button', {
    staticClass: "manual-stops",
    attrs: {
      "type": !_vm.is_manual ? 'primary' : 'default'
    },
    domProps: {
      "textContent": _vm._s(!_vm.is_manual ? 'Disable optimization' : 'Enable optimization')
    },
    on: {
      "click": function($event) {
        _vm.route_ready(false)
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-csv",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "on-success": _vm.uploadedFile,
      "on-progress": _vm.processUpload,
      "disabled": _vm.progress_import
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.progress_import,
      "type": "default"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t("UPLOADCSVFILE")) + "\n                    ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "el-step__description is-finish"
  })])])])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loaded || _vm.routing || _vm.progress_import),
      expression: "loaded || routing || progress_import"
    }],
    staticClass: "stop-steps",
    attrs: {
      "element-loading-text": _vm.loadingMessage
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ScrollbarStops",
    staticClass: "scrollbar",
    style: ({
      height: _vm.stepsHeight + 'px'
    })
  }, [_c('div', {
    ref: "stops"
  }, [_c('el-row', {
    ref: "stops"
  }, [_c('el-steps', {
    attrs: {
      "space": 200,
      "direction": "vertical",
      "active": 1
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moving_stop != null && _vm.moving_stop != 1),
      expression: "moving_stop!=null && moving_stop != 1"
    }],
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.moveStop(0)
      }
    }
  }, [_c('span', {
    attrs: {
      "transition": "bounce"
    }
  }, [_vm._v(" Move selected stop here! ")])])], 1), _vm._v(" "), _vm._l((_vm.listStops), function(stop, key) {
    return (key != 0) ? _c('div', {
      key: key,
      staticClass: "el-step is-vertical"
    }, [_c('div', {
      staticClass: "el-step__head is-finish is-text",
      style: ({
        'background-color': _vm.direction.RouteColor,
        'border-color': _vm.direction.RouteColor
      })
    }, [_c('div', {
      staticClass: "el-step__line is-vertical",
      style: ({
        'background-color': _vm.direction.RouteColor
      })
    }, [_c('i', {
      staticClass: "el-step__line-inner",
      staticStyle: {
        "transition-delay": "0ms",
        "height": "100%"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-step__icon"
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(key)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "el-step__main"
    }, [_c('div', {
      staticClass: "el-step__title is-finish"
    }, [_c('span', {
      style: ({
        'text-decoration': stop.deleted ? _vm.$t('LINE-THROUGH') : _vm.$t('NONE')
      })
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('STOP')) + " " + _vm._s((key)))])]), _vm._v(" "), (_vm.is_manual) ? _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.moving_stop == key || _vm.moving_stop == null),
        expression: "moving_stop == key || moving_stop == null"
      }],
      staticClass: "move-stop",
      attrs: {
        "size": "mini"
      },
      domProps: {
        "textContent": _vm._s(_vm.moving_stop == key ? 'Cancel moving' : 'Move stop')
      },
      on: {
        "click": function($event) {
          _vm.movingStop(key)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-card', {
      staticClass: "box-card",
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-popover', {
      staticClass: "stop-inputs",
      attrs: {
        "trigger": "manual",
        "placement": "right",
        "width": "400"
      },
      model: {
        value: (stop.inputs),
        callback: function($$v) {
          _vm.$set(stop, "inputs", $$v)
        },
        expression: "stop.inputs"
      }
    }, [_c('el-form', {
      ref: "form",
      refInFor: true,
      attrs: {
        "model": stop,
        "label-width": "120px",
        "label-position": "top"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('GPSLATITUDE')
      }
    }, [_c('el-input', {
      model: {
        value: (stop.Lat),
        callback: function($$v) {
          _vm.$set(stop, "Lat", $$v)
        },
        expression: "stop.Lat"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('GPSLONGITUDE')
      }
    }, [_c('el-input', {
      model: {
        value: (stop.Lng),
        callback: function($$v) {
          _vm.$set(stop, "Lng", $$v)
        },
        expression: "stop.Lng"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('USEGOOGLEMAPDURATION')
      }
    }, [_c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": 1
      },
      model: {
        value: (stop.mapDuration),
        callback: function($$v) {
          _vm.$set(stop, "mapDuration", $$v)
        },
        expression: "stop.mapDuration"
      }
    }, [_vm._v(_vm._s(_vm.$t('YES')))]), _vm._v(" "), _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": 0
      },
      model: {
        value: (stop.mapDuration),
        callback: function($$v) {
          _vm.$set(stop, "mapDuration", $$v)
        },
        expression: "stop.mapDuration"
      }
    }, [_vm._v(_vm._s(_vm.$t('NO')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('PREVIOUSWAITING')
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": stop.mapDuration === 0
      },
      model: {
        value: (stop.DeltaT),
        callback: function($$v) {
          _vm.$set(stop, "DeltaT", $$v)
        },
        expression: "stop.DeltaT"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 11
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('STOPWAITING')
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": stop.mapDuration === 0
      },
      model: {
        value: (stop.WaitingTime),
        callback: function($$v) {
          _vm.$set(stop, "WaitingTime", $$v)
        },
        expression: "stop.WaitingTime"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "popover-btn"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "text"
      },
      on: {
        "click": function($event) {
          stop.inputs = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          stop.inputs = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference",
        "icon": "setting"
      },
      on: {
        "click": function($event) {
          stop.inputs = true
        }
      },
      slot: "reference"
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "18px"
      },
      attrs: {
        "type": "text",
        "disabled": !_vm.noDragging
      },
      on: {
        "click": function($event) {
          _vm.deleteAction(stop, key)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: [stop.deleted ? 'fa-undo' : 'fa-trash']
    })])], 1)], 1)], 1), _vm._v(" "), (!_vm.noDragging && _vm.dragged_list[key] == undefined) ? _c('div', {
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.dropList(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-circle-down"
    }), _vm._v("\n                  Move selected student(s) to this stop\n                ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((stop.students), function(student, index) {
      return _c('el-row', {
        key: index,
        staticClass: "list",
        class: {
          'dragged': _vm.isDragged(student, true)
        }
      }, [_c('img', {
        staticClass: "img-circle",
        staticStyle: {
          "width": "50px"
        },
        attrs: {
          "src": _vm.getAsset(student.ImagePath, 'student')
        }
      }), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "text",
          "size": "large"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm._FullName({
        NameEN: student.FullName_EN,
        NameAR: student.FullName_AR
      })) + "\n                          "), (!stop.deleted && !_vm.isDragged(student, true)) ? _c('i', {
        staticClass: "fa",
        class: [student.deleted ? 'fa-undo' : 'fa-remove'],
        on: {
          "click": function($event) {
            _vm.deleteAction(student, key)
          }
        }
      }) : _vm._e()]), _vm._v(" "), (_vm.is_manual) ? _c('el-button', {
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.dragStudent(student)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-exchange",
        attrs: {
          "data-fa-transform": "rotate-180"
        }
      }), _vm._v(" \n                          " + _vm._s(_vm.isDragged(student, true) ? 'Cancel' : 'Change stop') + "\n                          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
        staticClass: "mapPin",
        style: ({
          color: _vm.direction.RouteColor
        }),
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.pinStudentLocation(student)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-map-pin fa-2x"
      })])], 1)
    }), _vm._v(" "), (stop.students != undefined) ? _c('el-row', [(stop.students.length == 0) ? _c('el-col', {
      staticStyle: {
        "padding": "10px",
        "background-color": "rgb(209, 219, 229)",
        "color": "#4b4b4b"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t('NOSTUDENTSADDEDTOTHISSTOP')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticClass: "only-top-border"
    })], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.moving_stop != null && _vm.moving_stop != key && _vm.moving_stop != key + 1),
        expression: "moving_stop!=null && moving_stop != key && moving_stop != key + 1"
      }],
      attrs: {
        "align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.moveStop(key)
        }
      }
    }, [_c('span', {
      attrs: {
        "transition": "bounce"
      }
    }, [_vm._v(" Move selected stop here! ")])])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "el-step__description is-finish"
    })])]) : _vm._e()
  })], 2)], 1)], 1)])], 1)], 1), _vm._v(" "), (_vm.isAllowed('registration')) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('REGISTRATION'),
      "disabled": _vm.loaded || _vm.registrationTab
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.tabHeight - 3 + 'px'
    })
  }, [_c('el-row', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SUPERVISOR')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v("\n            " + _vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })) + "  "), _c('el-checkbox', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isAllowed('registration', 'transportation/supervisor'),
      "label": _vm.monitor.BusMonitorID
    },
    model: {
      value: (_vm.selectedMonitor),
      callback: function($$v) {
        _vm.selectedMonitor = $$v
      },
      expression: "selectedMonitor"
    }
  }, [_vm._v(" ")]), _c('br')], 1), _vm._v(" "), (_vm.driver.EMail) ? _c('h4', [_vm._v(_vm._s(_vm.$t('DRIVER')))]) : _vm._e(), _vm._v(" "), (_vm.driver.EMail) ? _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v("\n            " + _vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })) + "  "), _c('el-checkbox', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isAllowed('registration', 'transportation/driver'),
      "label": _vm.driver.BusDriverID
    },
    model: {
      value: (_vm.tickedDriver),
      callback: function($$v) {
        _vm.tickedDriver = $$v
      },
      expression: "tickedDriver"
    }
  }, [_vm._v(" ")]), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "padding-right": "10px"
    },
    model: {
      value: (_vm.selectedStudents),
      callback: function($$v) {
        _vm.selectedStudents = $$v
      },
      expression: "selectedStudents"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('STUDENTS')))]), _vm._v(" "), _vm._l((_vm.stops), function(stop, index) {
    return _c('div', {
      key: index
    }, _vm._l((stop.students), function(student, index) {
      return _c('el-row', {
        key: index,
        staticClass: "list"
      }, [_c('img', {
        staticClass: "img-circle",
        staticStyle: {
          "width": "50px"
        },
        attrs: {
          "src": _vm.getAsset(student.ImagePath, 'student')
        }
      }), _vm._v("\n            " + _vm._s(_vm._FullName({
        NameEN: student.FullName_EN,
        NameAR: student.FullName_AR
      })) + " \n            "), _c('el-checkbox', {
        staticStyle: {
          "float": "right"
        },
        attrs: {
          "label": student.StudentID
        }
      }, [_vm._v(" ")]), _c('br')], 1)
    }))
  })], 2)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "height": "40px",
      "display": "block",
      "width": "100%",
      "border-radius": "0"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.sending,
      "disabled": _vm.selectedStudents.length === 0 && !_vm.selectedMonitor && !_vm.tickedDriver
    },
    on: {
      "click": _vm.sendRegistration
    }
  }, [_vm._v(" " + _vm._s(_vm.sending ? _vm.$t('SENDING') : _vm.$t('SENDREGISTRATIONCODE')))])], 1) : _vm._e(), _vm._v(" "), (_vm.route.TourID) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('SETTINGS'),
      "disabled": _vm.loading
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('STATUS')
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": !_vm.isAllowed('status'),
      "on-value": "0",
      "off-value": "1",
      "on-text": _vm.$t('ACTIVE'),
      "off-text": _vm.$t('INACTIVE'),
      "width": 80
    },
    on: {
      "change": _vm.status
    },
    model: {
      value: (_vm.route.Deleted),
      callback: function($$v) {
        _vm.$set(_vm.route, "Deleted", $$v)
      },
      expression: "route.Deleted"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('COPYROUTE')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('NAMEYOURROUTE'),
      "disabled": !_vm.isAllowed('clone')
    },
    model: {
      value: (_vm.clonedName),
      callback: function($$v) {
        _vm.clonedName = $$v
      },
      expression: "clonedName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": !_vm.clonedName && !_vm.isAllowed('clone'),
      "loading": _vm.cloning
    },
    on: {
      "click": _vm.cloneRoute
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.cloning ? _vm.$t('CLONING') : _vm.$t('MAKEACOPY')))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('DELAYEDTHRESHOLD')
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": _vm.$t('STARTTIME'),
      "size": "small",
      "picker-options": {
        start: '00:05',
        step: '00:5',
        end: '00:30'
      },
      "format": "hh:mm"
    },
    model: {
      value: (_vm.schedule.DelayedThreshold),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "DelayedThreshold", $$v)
      },
      expression: "schedule.DelayedThreshold"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 16,
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-tabs', {
    staticClass: "staff",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('OVERVIEW')
    }
  }, [_c('el-form', {
    ref: "OVForm",
    attrs: {
      "id": "OVForm",
      "model": _vm.route,
      "inline": true
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "BusID",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change,blur'
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-bus fa-3x"
  }), _vm._v(" "), _c('el-tag', [_vm._v("# " + _vm._s(_vm.bus.Label))])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "disabled": !_vm.stopTab,
      "content": _vm.$t('FILLINFORMATION'),
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "wrapper el-button"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.stopTab,
      "size": "small",
      "icon": _vm.route.TourID !== null ? 'edit' : 'plus'
    },
    on: {
      "click": _vm.getBuses
    }
  }, [_vm._v(_vm._s(_vm.$t('BUS')))])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border2",
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "BusMonitorID",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change,blur'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "disabled": !_vm.ellipsis,
      "content": _vm._FullName({
        NameEN: _vm.monitor.FullName_EN,
        NameAR: _vm.monitor.FullName_AR
      }) === undefined ? '&zwnj;' : _vm._FullName({
        NameEN: _vm.monitor.FullName_EN,
        NameAR: _vm.monitor.FullName_AR
      })
    }
  }, [_c('span', {
    staticClass: "overflow-text",
    on: {
      "mouseover": _vm.isEllipsisActive
    }
  }, [_vm._v(_vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  }) === undefined ? '‌' : _vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })))])])], 1)]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "disabled": !_vm.stopTab,
      "content": _vm.$t('FILLINFORMATION'),
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "wrapper el-button"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.stopTab,
      "size": "small",
      "icon": _vm.route.TourID !== null ? 'edit' : 'plus'
    },
    on: {
      "click": _vm.getSupervisors
    }
  }, [_vm._v(_vm._s(_vm.$t('SUPERVISOR')))])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "BusDriverID",
      "rules": {
        required: true,
        message: _vm.$t('ISREQUIRED'),
        trigger: 'change,blur'
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "disabled": !_vm.ellipsis,
      "content": _vm._FullName({
        NameEN: _vm.driver.FullName_EN,
        NameAR: _vm.driver.FullName_AR
      }) === undefined ? '&zwnj;' : _vm._FullName({
        NameEN: _vm.driver.FullName_EN,
        NameAR: _vm.driver.FullName_AR
      })
    }
  }, [_c('span', {
    staticClass: "overflow-text",
    on: {
      "mouseover": _vm.isEllipsisActive
    }
  }, [_vm._v(_vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  }) === undefined ? '‌' : _vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })))])])], 1)]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "disabled": !_vm.stopTab,
      "content": _vm.$t('FILLINFORMATION'),
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "wrapper el-button"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.stopTab,
      "size": "small",
      "icon": _vm.route.TourID !== null ? 'edit' : 'plus'
    },
    on: {
      "click": _vm.getDrivers
    }
  }, [_vm._v(_vm._s(_vm.$t('DRIVER')))])], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "15px"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "position": "relative",
      "margin": "0 -15px"
    }
  }, [_c('div', {
    style: ({
      height: _vm.cardHeight - 122 + 'px'
    }),
    attrs: {
      "id": "gmap-route"
    }
  })])], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Trips"
    }
  }, [_vm._v(_vm._s(_vm.$t('TRIPS')))]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Violations"
    }
  }, [_vm._v(_vm._s(_vm.$t('VIOLATIONS')))]) : _vm._e(), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Incidents"
    }
  }, [_vm._v(_vm._s(_vm.$t('INCIDENTS')))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('SELECTBUS'),
      "size": "small"
    },
    on: {
      "close": function($event) {
        _vm.clearSelections()
      }
    },
    model: {
      value: (_vm.showBuses),
      callback: function($$v) {
        _vm.showBuses = $$v
      },
      expression: "showBuses"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SELECTEDBUS')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('el-tag', [_vm._v("# " + _vm._s(_vm.bus.Label))])], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('AVAILABLEBUSES')))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuses),
      expression: "loadingBuses"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "default-sort": {
        prop: 'RouteID'
      },
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredData,
      "highlight-current-row": "",
      "height": 500,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Label",
      "render-header": _vm.headerFilter,
      "min-width": "135",
      "label": _vm.$t('BUSNUMBER'),
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Model",
      "label": _vm.$t('MODEL'),
      "min-width": "95",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Year",
      "label": _vm.$t('YEAR'),
      "align": "center",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MaxSeats",
      "label": _vm.$t('SEATS'),
      "align": "center",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "align": "center",
      "prop": "RouteID",
      "min-width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.RouteID == null) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('NOTASSIGNED')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BusID !== _vm.route.BusID) ? _c('el-button', {
          attrs: {
            "loading": _vm.assigning[scope.row.BusID],
            "type": _vm.selectedBus == scope.row.BusID ? 'primary' : 'default'
          },
          on: {
            "click": function($event) {
              _vm.assignProcess(scope.row.BusID, scope.row.Label, 'Bus')
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.selectedBus == scope.row.BusID ? 'PLEASECONFIRM' : _vm.assigning[scope.row.BusID] ? 'ASSIGNING' : 'ASSIGN')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showBuses = _vm.item_checked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedBus === _vm.route.BusID || _vm.selectedBus === null
    },
    on: {
      "click": _vm.setBus
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('SELECTDRIVER'),
      "size": "small"
    },
    on: {
      "close": function($event) {
        _vm.clearSelections()
      }
    },
    model: {
      value: (_vm.showDrivers),
      callback: function($$v) {
        _vm.showDrivers = $$v
      },
      expression: "showDrivers"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SELECTEDDRIVER')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v("\n        " + _vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })) + "\n            ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('AVAILABLEDRIVERS')))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingDrivers),
      expression: "loadingDrivers"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "default-sort": {
        prop: 'RouteID'
      },
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredData,
      "highlight-current-row": "",
      "height": 500,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "render-header": _vm.headerFilter,
      "min-width": "150",
      "prop": "FullName_EN",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'driver'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        }) + _vm.$t('')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LicenseExpiration",
      "label": _vm.$t('LICENSEEXPIRATION'),
      "min-width": "145",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "min-width": "102",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.$countries[scope.row.Nationality]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "108",
      "prop": "RouteID",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.RouteID == null) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('NOTASSIGNED')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "95",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BusDriverID !== _vm.route.BusDriverID) ? _c('el-button', {
          attrs: {
            "loading": _vm.assigning[scope.row.BusDriverID],
            "type": _vm.selectedDriver == scope.row.BusDriverID ? 'primary' : 'default'
          },
          on: {
            "click": function($event) {
              _vm.assignProcess(scope.row.BusDriverID, _vm._FullName({
                NameEN: scope.row.FullName_EN,
                NameAR: scope.row.FullName_AR
              }), 'Driver')
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.selectedDriver == scope.row.BusDriverID ? 'PLEASECONFIRM' : _vm.assigning[scope.row.BusDriverID] ? 'ASSIGNING' : 'ASSIGN')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDrivers = _vm.item_checked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedDriver === _vm.route.BusDriverID || _vm.selectedDriver === null
    },
    on: {
      "click": _vm.setDriver
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('SELECTSUPERVISOR'),
      "callback": _vm.clearEverything,
      "size": "small"
    },
    on: {
      "close": function($event) {
        _vm.clearSelections()
      }
    },
    model: {
      value: (_vm.showSupervisors),
      callback: function($$v) {
        _vm.showSupervisors = $$v
      },
      expression: "showSupervisors"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('SELECTEDSUPERVISOR')))]), _vm._v(" "), _c('el-row', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v("\n        " + _vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })) + "\n            ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('AVAILABLESUPERVISORS')))]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSupervisors),
      expression: "loadingSupervisors"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "default-sort": {
        prop: 'RouteID'
      },
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.filteredData,
      "highlight-current-row": "",
      "height": 500,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "render-header": _vm.headerFilter,
      "min-width": "200",
      "prop": "FullName_EN",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'supervisor'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        }) + _vm.$t('')) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NATIONALITY'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.$countries[scope.row.Nationality]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('STATUS'),
      "min-width": "120",
      "prop": "RouteID",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.RouteID == null) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('NOTASSIGNED')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.BusMonitorID !== _vm.route.BusMonitorID) ? _c('el-button', {
          attrs: {
            "loading": _vm.assigning[scope.row.BusMonitorID],
            "type": _vm.selectedSupervisor == scope.row.BusMonitorID ? 'primary' : 'default'
          },
          on: {
            "click": function($event) {
              _vm.assignProcess(scope.row.BusMonitorID, _vm._FullName({
                NameEN: scope.row.FullName_EN,
                NameAR: scope.row.FullName_AR
              }), 'Supervisor')
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.selectedSupervisor == scope.row.BusMonitorID ? 'PLEASECONFIRM' : _vm.assigning[scope.row.BusMonitorID] ? 'ASSIGNING' : 'ASSIGN')) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSupervisors = _vm.item_checked = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedSupervisor === _vm.route.BusMonitorID || _vm.selectedSupervisor === null
    },
    on: {
      "click": _vm.setSupervisor
    }
  }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ERROR'),
      "size": "tiny"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('div', {
    staticClass: "el-alert el-alert--error"
  }, [_c('i', {
    staticClass: "el-alert__icon el-icon-circle-cross is-big"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-alert__content"
  }, _vm._l((_vm.message), function(messageError, index) {
    return _c('span', {
      key: index,
      staticClass: "el-alert__title is-bold",
      domProps: {
        "innerHTML": _vm._s(_vm.printError(messageError))
      }
    })
  }))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CLOSE')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-684e8525"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transportation/RouteManage.vue
// module id = 609
// module chunks = 1